/** A native select or textarea styled as the UI kit's Input, red when it carries aria-invalid. */
export const FIELD_CLASS =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50 aria-[invalid=true]:border-destructive';
